import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPricetag = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		id: "Vector",
		d: "M13.6016 1.5H9.76094C9.64152 1.49991 9.52692 1.5471 9.44219 1.63125L1.76406 9.30938C1.59594 9.47832 1.50156 9.70697 1.50156 9.94531C1.50156 10.1837 1.59594 10.4123 1.76406 10.5813L5.42031 14.2375C5.58926 14.4056 5.81791 14.5 6.05625 14.5C6.29459 14.5 6.52324 14.4056 6.69219 14.2375L14.3672 6.5625C14.4513 6.47777 14.4985 6.36317 14.4984 6.24375V2.4C14.499 2.28191 14.4762 2.16488 14.4314 2.05563C14.3866 1.94638 14.3206 1.84707 14.2372 1.76342C14.1539 1.67978 14.0548 1.61344 13.9457 1.56823C13.8366 1.52302 13.7197 1.49983 13.6016 1.5Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		id: "Vector_2",
		d: "M12 5C11.8022 5 11.6089 4.94135 11.4444 4.83147C11.28 4.72159 11.1518 4.56541 11.0761 4.38268C11.0004 4.19996 10.9806 3.99889 11.0192 3.80491C11.0578 3.61093 11.153 3.43275 11.2929 3.29289C11.4327 3.15304 11.6109 3.0578 11.8049 3.01922C11.9989 2.98063 12.2 3.00043 12.3827 3.07612C12.5654 3.15181 12.7216 3.27998 12.8315 3.44443C12.9414 3.60888 13 3.80222 13 4C13 4.26522 12.8946 4.51957 12.7071 4.70711C12.5196 4.89464 12.2652 5 12 5Z",
		fill: "currentColor",
		stroke: "currentColor",
		strokeWidth: .03125
	})]
});
export default SvgPricetag;
